module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "boxborder",
    style: ({
      transform: _vm.scaling
    }),
    attrs: {
      "id": "boxborder"
    }
  }, [_c('div', {
    attrs: {
      "id": "generatorcontainer"
    }
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    style: ({
      backgroundImage: _vm.imageLinkBG
    }),
    attrs: {
      "src": _vm.imageLink
    }
  }), _vm._v(" "), _c('ul', {
    class: {
      rotated: _vm.isRotated
    },
    style: ([_vm.containerStyle, _vm.customContainerVersionStyle]),
    attrs: {
      "id": "textcontainer"
    }
  }, [_vm._l((_vm.lines), function(line) {
    return _c('block', {
      attrs: {
        "real-time": true,
        "text": line.text,
        "type": line.style,
        "fontSize": line.fontSize
      }
    })
  }), _vm._v(" "), _c('br'), _c('br')], 2)]), _vm._v(" "), (_vm.showDisclaimer) ? _c('div', {
    staticStyle: {
      "font-weight": "500",
      "width": "100%",
      "text-align": "center",
      "color": "#999",
      "font-size": "14px",
      "padding": "10px 20px",
      "background-color": "#EEE"
    }
  }, [_vm._v("Dies Meisterwerk ist kein offizielles Plakat, es wurde mit "), _c('strong', {
    staticStyle: {
      "opacity": "0.9",
      "background-image": "linear-gradient(-70deg, #3023AE, #C86DD7)",
      "-webkit-background-clip": "text",
      "-webkit-text-fill-color": "transparent"
    }
  }, [_vm._v("plakatgenerator.com")]), _vm._v(" erstellt")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "builder"
  }, [_vm._l((_vm.lines), function(line, index) {
    return _c('div', {
      staticClass: "builder-line"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (line.text),
        expression: "line.text"
      }],
      staticClass: "input",
      attrs: {
        "name": "",
        "value": ""
      },
      domProps: {
        "value": (line.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(line, "text", $event.target.value)
        }
      }
    }), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "5px 0",
        "margin-top": "5px"
      }
    }, [_c('label', {
      staticClass: "label"
    }, [_vm._v("GRÖSSE:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (line.fontSize),
        expression: "line.fontSize"
      }],
      attrs: {
        "type": "range",
        "min": "0",
        "max": "100"
      },
      domProps: {
        "value": (line.fontSize)
      },
      on: {
        "__r": function($event) {
          return _vm.$set(line, "fontSize", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (line.fontSize),
        expression: "line.fontSize"
      }],
      attrs: {
        "type": "number",
        "min": "0",
        "max": "100"
      },
      domProps: {
        "value": (line.fontSize)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(line, "fontSize", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-bottom": "5px"
      }
    }, [_c('label', {
      staticClass: "label"
    }, [_vm._v("STIL:")]), _vm._v(" "), _c('div', {
      staticClass: "select is-small"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (line.style),
        expression: "line.style"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(line, "style", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.styles), function(style, index) {
      return _c('option', {
        domProps: {
          "value": index
        }
      }, [_c('div', {
        staticStyle: {
          "width": "10px",
          "height": "10px",
          "background-color": "red"
        }
      }, [_vm._v(_vm._s(style.name))])])
    }), 0)]), _vm._v(" "), _c('button', {
      staticClass: "button is-small",
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeLine(index)
        }
      }
    }, [_vm._v("\n           X\n         ")])])])
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.addLine
    }
  }, [_vm._v("Box Hinzufügen\n     ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "disclaimer",
    staticStyle: {
      "max-width": "800px"
    }
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showDisclaimer),
      expression: "showDisclaimer"
    }],
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showDisclaimer) ? _vm._i(_vm.showDisclaimer, null) > -1 : (_vm.showDisclaimer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showDisclaimer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showDisclaimer = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showDisclaimer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showDisclaimer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Disclaimer anzeigen?")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-left": "27px",
      "padding-top": "5px"
    }
  }, [_vm._v("Aus Gründen sind die diesjährigen Plakate standardmäßig mit einem Disclaimer versehen, dass es sich nicht um ein offizielles Plakat handelt. Situationselastisch kann er mit dieser Checkbox entfernt werden.")])])]), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('a', {
    class: {
      disabled: _vm.loadingDownload
    },
    attrs: {
      "name": "button",
      "id": "downloadbutton"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("DOWNLOAD\n       "), (_vm.loadingDownload) ? _c('spinner', {
    staticStyle: {
      "top": "-3px",
      "margin-left": "10px"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.statusText) ? _c('p', {
    staticStyle: {
      "max-width": "500px",
      "margin": "20px auto"
    }
  }, [_vm._v(_vm._s(_vm.statusText))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51e4fdc9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Builder.vue
// module id = 228
// module chunks = 1